import { createSlice } from '@reduxjs/toolkit'

import { TransferwiseRequirement } from 'src/Types/payments'
import { setApiError } from 'src/Hooks/redux'

import { ApiError, NameSpace } from '../types'

import {
  getCreatorTransferwiseAccountRequirements,
  getCuratorTransferwiseAccountRequirements,
  getTransferwiseAccountRequirements,
  specifyCreatorTransferwiseAccountRequirements,
  specifyCuratorTransferwiseAccountRequirements,
  specifyTransferwiseAccountRequirements,
} from './api-actions'

export interface WiseState {
  requirements: Array<TransferwiseRequirement>
  loading: boolean
  error: ApiError | null
}

const initialState: WiseState = {
  requirements: [],
  loading: false,
  error: null,
}

export const wiseProcess = createSlice({
  initialState,
  name: NameSpace.Wise,
  reducers: {
    setRequirementsToInitialState(state) {
      state.requirements = []
    },
  },
  extraReducers: (builder) => {
    // getTransferwiseAccountRequirements
    builder.addCase(getTransferwiseAccountRequirements.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getTransferwiseAccountRequirements.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.requirements = payload
      },
    )
    builder.addCase(
      getTransferwiseAccountRequirements.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action)
      },
    )
    // getCreatorTransferwiseAccountRequirements
    builder.addCase(
      getCreatorTransferwiseAccountRequirements.pending,
      (state) => {
        state.loading = true
      },
    )
    builder.addCase(
      getCreatorTransferwiseAccountRequirements.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.requirements = payload
      },
    )
    builder.addCase(
      getCreatorTransferwiseAccountRequirements.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action)
      },
    )
    // getCuratorTransferwiseAccountRequirements
    builder.addCase(
      getCuratorTransferwiseAccountRequirements.pending,
      (state) => {
        state.loading = true
      },
    )
    builder.addCase(
      getCuratorTransferwiseAccountRequirements.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.requirements = payload
      },
    )
    builder.addCase(
      getCuratorTransferwiseAccountRequirements.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action)
      },
    )

    // specifyTransferwiseAccountRequirements
    builder.addCase(specifyTransferwiseAccountRequirements.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      specifyTransferwiseAccountRequirements.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.requirements = payload
      },
    )
    builder.addCase(
      specifyTransferwiseAccountRequirements.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action)
      },
    )

    // specifyCreatorTransferwiseAccountRequirements
    builder.addCase(
      specifyCreatorTransferwiseAccountRequirements.pending,
      (state) => {
        state.loading = true
      },
    )
    builder.addCase(
      specifyCreatorTransferwiseAccountRequirements.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.requirements = payload
      },
    )
    builder.addCase(
      specifyCreatorTransferwiseAccountRequirements.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action)
      },
    )
    // specifyCuratorTransferwiseAccountRequirements
    builder.addCase(
      specifyCuratorTransferwiseAccountRequirements.pending,
      (state) => {
        state.loading = true
      },
    )
    builder.addCase(
      specifyCuratorTransferwiseAccountRequirements.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.requirements = payload
      },
    )
    builder.addCase(
      specifyCuratorTransferwiseAccountRequirements.rejected,
      (state, action) => {
        state.loading = false
        state.error = setApiError(action)
      },
    )
  },
})

export const { setRequirementsToInitialState } = wiseProcess.actions
